import React from 'react'
import { Col, Row } from 'react-bootstrap'
import './RelatedCourses.css'
import CoursesItem from '../CoursesItem/CoursesItem.'
import { shuffle } from 'lodash';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
export default function RelatedCourses({ courseList }) {
    const colors = ['#7443FF', '#69B721', '#5F0101', '#7345FB', '#83CD1A', '#34ebe1', '#c034eb'];
    const shuffledColors = shuffle(colors);
    return (
        <div className='related-courses'>
            <div className='related-courses-title'>
                <h3>دوره های مرتبط</h3>
            </div>
            <div className='related-courses-item'>
                <Row>
                    {
                        courseList.slice(0, 4).map((item, index) => (
                            <Col lg={3}>
                                <CoursesItem item={item} backgroundColor={shuffledColors[index]} />
                            </Col>
                        ))
                    }
                </Row>
            </div>
            <div className='related-courses-item-responsive'>
                <Swiper
                    slidesPerView={2}
                    spaceBetween={10}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        0: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        },
                        300: {
                            slidesPerView: 1.5,
                            spaceBetween: 20,
                        },
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 40,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 40,
                        },
                    }}
                    modules={[Autoplay]}
                    className="mySwiper"
                >
                    {
                        courseList.slice(0, 8).map((course,index) => (
                            <SwiperSlide>
                                <CoursesItem item={course} backgroundColor={shuffledColors[index]} />
                            </SwiperSlide>
                        ))
                    }

                </Swiper>
            </div>
        </div>
    )
}
